import { app, Component } from "modular-openscriptjs";
import motivationalStatements from "./motivationalStatements";

const h = app("h");
const $e = app("$e");

export default class UnAuthenticatedIndex extends Component {
	getDayOfYear() {
		const now = new Date();
		const start = new Date(now.getFullYear(), 0, 0);
		const diff = now - start;
		const oneDay = 1000 * 60 * 60 * 24;
		const day = Math.floor(diff / oneDay);
		// Clamping between 1 and 366 just in case
		return Math.min(366, Math.max(1, day));
	}

	getGreeting() {
		const hour = new Date().getHours();
		if (hour >= 5 && hour < 12) {
			return { text: "Good Morning, Rider!", icon: "bi-sun-fill" };
		} else if (hour >= 12 && hour < 18) {
			return { text: "Good Afternoon, Rider!", icon: "bi-cloud-sun-fill" };
		} else {
			return { text: "Good Evening, Rider!", icon: "bi-moon-stars-fill" };
		}
	}

	render(...args) {
		const dayOfYear = this.getDayOfYear();
		// Index is 0-based
		const statement = motivationalStatements[dayOfYear - 1] || "Ride safe and make today count!";
		const greeting = this.getGreeting();

		return h.section(
			{
				class: "section-hero-premium position-fixed d-flex align-items-center justify-content-center p-3 text-white",
				style: "background: linear-gradient(135deg, #2a0827 0%, #973e87 50%, #fed27d 100%); top: 0 !important; bottom: 0 !important; left: 0 !important; right: 0 !important; height: 100vh !important; z-index: 9999; overflow-y: auto;",
			},

			// Animated backdrop glow elements
			h.div({
				style: "position: absolute; width: 300px; height: 300px; background: rgba(254, 210, 125, 0.15); filter: blur(80px); top: 10%; left: 10%; border-radius: 50%; pointer-events: none;",
			}),
			h.div({
				style: "position: absolute; width: 400px; height: 400px; background: rgba(151, 62, 135, 0.25); filter: blur(100px); bottom: 10%; right: 5%; border-radius: 50%; pointer-events: none;",
			}),

			// Main Container
			h.div(
				{
					class: "w-100 text-center position-relative px-2",
					style: "max-width: 500px; z-index: 5; padding-block: 2rem;",
				},

				// Logo and Badge
				h.div(
					{ class: "mb-4 d-inline-flex flex-column align-items-center" },
					h.div(
						{
							class: "rounded-circle p-3 mb-3 d-flex align-items-center justify-content-center shadow",
							style: "background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px); width: 80px; height: 80px; border: 1px solid rgba(255, 255, 255, 0.35);",
						},
						h.img({
							src: "/assets/images/logo.png",
							alt: "Carata Logo",
							style: "height: 42px; width: auto; filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.1));",
						}),
					),
					h.span(
						{
							class: "badge rounded-pill px-3 py-2 text-uppercase fw-bold shadow-sm",
							style: "background: #fed27d; color: #532520; font-size: 0.75rem; letter-spacing: 1.5px;",
						},
						"Carata Rider"
					),
				),

				// Greeting
				h.h2(
					{
						class: "fw-bold mb-4 d-flex align-items-center justify-content-center gap-2",
						style: "font-size: 1.75rem; text-shadow: 0 2px 4px rgba(0,0,0,0.3);",
					},
					h.i({ class: `bi ${greeting.icon}`, style: "color: #fed27d;" }),
					greeting.text
				),

				// Glassmorphic Quote Card
				h.div(
					{
						class: "card border-0 shadow rounded-4 p-4 mb-5 mx-2 text-start position-relative overflow-hidden",
						style: "background: rgba(255, 255, 255, 0.1); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border: 1px solid rgba(255, 255, 255, 0.15);",
					},
					// Big quote mark icon in background
					h.i({
						class: "bi bi-quote position-absolute",
						style: "font-size: 8rem; color: rgba(254, 210, 125, 0.08); right: -10px; bottom: -30px; line-height: 1; pointer-events: none;",
					}),
					// Label/Heading inside card
					h.div(
						{
							class: "d-flex align-items-center gap-2 mb-3",
							style: "color: #fed27d; font-size: 0.85rem; font-weight: 700; text-uppercase; letter-spacing: 1px;",
						},
						h.i({ class: "bi bi-lightning-charge-fill" }),
						"Today's Motivation"
					),
					// The Statement
					h.p(
						{
							class: "fs-5 fw-medium mb-0 lh-base",
							style: "color: #ffffff; text-shadow: 0 1px 2px rgba(0,0,0,0.1);",
						},
						statement
					),
				),

				// Energetic Login CTA Button
				h.button(
					{
						class: "btn btn-lg w-100 fw-bold py-3 px-4 rounded-pill shadow-lg d-flex align-items-center justify-content-center gap-3 border-0 position-relative overflow-hidden hero-premium-cta",
						style: "background: linear-gradient(135deg, #fed27d 0%, #f7b131 100%); color: #532520; font-size: 1.15rem; transition: all 0.3s ease; animation: pulse-glow 2.5s infinite;",
						onclick: `sendEvent('${$e.user.needs.authentication}')`,
						aria_label: "Start Riding",
					},
					h.i({ class: "bi bi-bicycle fs-4" }),
					"Start Riding",
					h.i({ class: "bi bi-arrow-right fs-5" })
				),
			),

			...args
		);
	}
}
